import React from 'react';

import ReactHtmlParser from 'react-html-parser';
import { useDispatch } from 'react-redux';

import { changedAgreement } from '../../../../store/actions';
import SliderFormField from '../../../SliderFormField/SliderFormField';
import '../FormPage.scss';

export default function FormPageAgreement({ agreements }) {
  const dispatch = useDispatch();

  const agreementsMap = agreements.map((agreement, index) => {
    return (
      <tr key={index} className="FormPage__tr">
        <td className="FormPage__td">
          <SliderFormField
            checked={agreement.checked}
            onChange={() => dispatch(changedAgreement(agreement))}
          />
        </td>
        <td className="FormPage__td">
          <p
            className={
              agreement.is_required
                ? 'FormPage__title-required'
                : 'FormPage__title'
            }
          >
            {ReactHtmlParser(agreement.message)}
          </p>
        </td>
      </tr>
    );
  });

  return (
    <table className="FormPage__sliders">
      <tbody className="FormPage__tbody">{agreementsMap}</tbody>
    </table>
  );
}
